import { Icon, symbolName } from './Icon'

type SendIconProps = Readonly<{
  size?: number
  color?: string
}>

export function SendIcon({ size = 16, color = '#FEFBFB' }: SendIconProps) {
  return (
    <Icon
      name={symbolName('paperplane.fill', 'send')}
      size={size}
      color={color}
    />
  )
}
